<!-- prettier-ignore -->

@if(pointsPerDay() && pointsPerDay()?.length > 0){
    <div #myDiv class="divMapPoints">
        @for (point of pointsPerDay(); track $index;) {
            <div class="cardNewRoute" style="overflow: visible;" (click)="openModalMobile(point)">
                <div class="badge" [ngStyle]="{'background-color': mobileCardColor()}">{{ $index + 1 }}</div>
                <div class="cardMobile">
                  <div class="cardimageMapBottomMobile">
                    <img [src]="point?.cover_image" >
                  </div>
                  <div class="cardImageDivBottomMobile">
                    <div class="cardImageDivBottomMobile__text-container">
                      <span>{{point?.name?.[translate.currentLang]}}</span>
                    </div>
                  </div>
                </div>
              </div>
        }
    </div>
}
